import { validateResourceName } from "@/utils/validation/resourceName"

const REPORT_NAME_MAX_LENGTH = 200

export function validateReportName(value: string) {
  const result = validateResourceName(value, {
    resource: "report",
    maxLength: REPORT_NAME_MAX_LENGTH,
  })

  return {
    name: result.name,
    error: result.status === "invalid" ? result.message : undefined,
  }
}
